import { Link } from 'react-scroll';

const CtaSection = () => (
  <section
    id="cta"
    className="relative py-24 md:py-32 overflow-hidden"
  >
    <div
      className="absolute inset-0 bg-cover bg-center"
      style={{
        backgroundImage:
          "url('https://public.readdy.ai/ai/img_res/4f6e8c57671f59e4aa036487f22b9000.jpg')",
      }}
    />
    <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/70 to-black/60" />

    <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center">
      <h2 className="text-3xl md:text-5xl font-extrabold text-white leading-tight mb-6">
        Ready to Get More Customers<br />
        <span className="text-orange-400">Coming In Consistently?</span>
      </h2>
      <p className="text-white/70 text-lg mb-10 max-w-xl mx-auto">
        Let's have a straight conversation about your business. No pitch, no pressure — just a clear look at what's possible and how to get there.
      </p>
      <Link
        to="form"
        smooth
        duration={500}
        offset={-80}
        className="whitespace-nowrap cursor-pointer inline-block px-10 py-5 bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg rounded-xl transition-all"
      >
        Book a Strategy Call
      </Link>
      <p className="text-white/40 text-sm mt-5 italic">No contracts. No fluff. Just results.</p>
    </div>
  </section>
);

export default CtaSection;
